import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  timeInputTitle: {
    // height: '16px',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,
    marginBottom: '5px',
  },
  timeInputTextHelper: {
    fontSize: '10px',
    // marginLeft: '0.15rem',
    marginLeft: '5px',
    fontWeight: 400,
  },
  timeSpacer: {
    marginTop: '6px',
    marginLeft: '4px',
    marginRight: '4px',
    fontSize: '14px',
    fontWeight: 500,
  },
  groupInput: {
    display: 'flex',
    width: '100%',
    marginBottom: '4px',
    // height: '36px', // TODO fix out how increase box size and veritcal align :

    '& > input': {
      width: '34px',
      height: '30px',
      fontSize: '14px',
      borderRadius: '2px',
      border: '1px solid #c0c0c0',
      textAlign: 'center',
      '&:last-child': {
        width: '35px',
      },
    },

    '& > input[type="number"]::-webkit-inner-spin-button': {
      appearance: 'none',
      margin: 0,
    },

    '& > input[type="number"]::-webkit-outer-spin-button': {
      appearance: 'none',
      margin: 0,
    },

    '& > input:focus': {
      outline: 'none',
      border: '1px solid #CCE',
    },
  },
}));
